import { render, staticRenderFns } from "./Report-5.vue?vue&type=template&id=5795c944&scoped=true"
import script from "./Report-5.vue?vue&type=script&lang=js"
export * from "./Report-5.vue?vue&type=script&lang=js"
import style0 from "./Report-5.vue?vue&type=style&index=0&id=5795c944&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5795c944",
  null
  
)

export default component.exports